var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEffectBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 150,
    viewBox: "0 0 136 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.639 0.498808V70.8955C118.639 71.2272 118.639 72.9431 118.582 75.4712C117.168 74.4043 115.687 73.43 114.147 72.5542C106.28 68.1597 97.1892 66.4519 88.2598 67.6909C79.3305 68.9299 71.0514 73.0479 64.6836 79.4177C58.4604 85.4379 54.4 93.3386 53.1315 101.896C52.807 104.085 52.6461 106.295 52.6502 108.508C52.4854 117.455 55.3661 126.194 60.8214 133.296L60.8902 133.388H48.9829C43.6137 133.388 38.333 132.022 33.6391 129.42C28.9451 126.818 24.9925 123.066 22.1541 118.517C19.0305 114.302 17.3471 109.197 17.3522 103.955V0.430176H0.746094V105.751C0.749132 117.409 5.39026 128.589 13.6491 136.832C21.908 145.076 33.1085 149.708 44.7883 149.711H135.222V0.498808H118.639ZM69.4626 104.081C70.3287 99.1126 72.7762 94.5556 76.4419 91.0856C76.7055 90.8111 76.992 90.548 77.2786 90.2849C80.782 86.9864 85.221 84.8489 89.9881 84.165C91.2864 83.9803 92.5962 83.8886 93.9076 83.8904C100.075 83.8794 106.024 86.1734 110.582 90.3209C115.14 94.4683 117.978 100.169 118.536 106.3C118.593 107.043 118.628 107.787 118.628 108.588V133.376H93.9649C87.4007 133.308 81.1249 130.674 76.4841 126.039C71.8433 121.405 69.2073 115.14 69.1417 108.588C69.1159 107.079 69.2233 105.571 69.4626 104.081Z",
    fill: "#663399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.134 16.2502H33.042V22.7134H103.134V16.2502Z",
    fill: "#663399"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.134 30.6865H33.042V37.1497H103.134V30.6865Z",
    fill: "#663399"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.134 45.1338H33.042V51.5969H103.134V45.1338Z",
    fill: "#663399"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffectBackground);
export default __webpack_public_path__ + "static/media/effect-background.283af79bd324282a8d8d6af3ba507431.svg";
export { ForwardRef as ReactComponent };